import { Segment } from "@/types/types.ts"
import * as React from "react";
import {
  SegmentTableRowPlayerProgressBarSlider
} from "@/features/AudioWorkstation/components/AudioEditorTabs/EditorTabPane/SegmentTableRowPlayerProgressBarSlider.tsx";
import useSegmentProgress from "@/common/hooks/useSegmentProgress.ts";

type Props = {
  segment: Segment
}

export const SegmentTableRowPlayerProgress = (props: Props) => {
  const {
    progress,
    currentTime,
    timeLeft,
  } = useSegmentProgress(props.segment)

  return <SegmentTableRowPlayerProgressBarSlider
    segment={props.segment}
    progress={progress || 0}
    currentTime={currentTime || 0}
    timeLeft={timeLeft || 0}
  />
}
